angular.module('leanlaw').filter("customFieldFilter", () => {
  return (fields, field) => {
    const {
      valueType,
      invoiceOnly
    } = field;
    return fields && fields.filter(f => valueTypeMatch(f, valueType) && invoiceOnlyMatch(f, invoiceOnly));
  };
  function valueTypeMatch(field, valueType) {
    if (valueType === 'text') return true;
    if (field.type === 'text') return valueType === 'text';
    if (field.type === 'number') return valueType === 'number';
    if (field.type === 'date') return valueType === 'date';
    if (field.type === 'user') return valueType === 'enum';
    if (field.type === 'matterTag') return valueType === 'enum';
    return false;
  }
  function invoiceOnlyMatch(field, invoiceOnly) {
    return !invoiceOnly || field.categories.indexOf('invoice') >= 0;
  }
});